import auth from "../../middlewares/auth";
export const settingsSemestersRoute = [
  {
    path: '/settings/semesters',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/semester/SemesterList'),
    name: 'settings_semesters',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/semesters/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/semester/SemesterForm'),
    name: 'settings_semester_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/semesters/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/semester/SemesterForm'),
    name: 'settings_semester_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];